import { gql } from "@apollo/client";

export const SoftDeleteScheduledEmpowerMeTask = gql`
  mutation SoftDeleteScheduledEmpowerMeTask($id: String!) {
    softDeleteScheduledEmpowerMeTask(id: $id) {
      _id
    }
  },
`;

export const SoftDeleteScheduledEmpowerMeTaskBundle = gql`
  mutation SoftDeleteScheduledEmpowerMeTaskBundle($bundle_id: String!) {
    softDeleteScheduledEmpowerMeTaskMultiple(bundle_id: $bundle_id) {
      _id
    }
  },
`;
